import { render, staticRenderFns } from "./PerformanceRequestForm.vue?vue&type=template&id=c8d4b0a6"
import script from "./PerformanceRequestForm.vue?vue&type=script&lang=js"
export * from "./PerformanceRequestForm.vue?vue&type=script&lang=js"
import style0 from "./PerformanceRequestForm.vue?vue&type=style&index=0&id=c8d4b0a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports